<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="800">
      <v-form ref="StudentCoretimeForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center">
            <span>{{ action }} Coretime</span>
            <v-spacer></v-spacer>
            <v-btn icon="mdi-close" variant="text" @click="closeD()"> </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Date From"
                    :model-value="formatDate(date_from)"
                    variant="outlined"
                    density="compact"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Date To"
                    :model-value="formatDate(date_to)"
                    variant="outlined"
                    density="compact"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <div
                    class="text-subtitle-1 font-weight-bold d-flex justify-space-between"
                  >
                    <div v-if="action == 'Add'">Set day and time schedule</div>
                    <div v-if="action == 'Add'">
                      <v-btn
                        :color="$vuetify.theme.themes.light.submitBtnsGreen"
                        class="white--text"
                        density="comfortable"
                        variant="flat"
                        @click="setT()"
                        size="small"
                        >Set</v-btn
                      >
                    </div>
                  </div>

                  <!-- <div class="d-flex flex-wrap ga-6 justify-space-around mt-4">
                    <div
                      class="pa-2 rounded-lg border border-1 box"
                      v-for="i in timeSchedule"
                      :key="i"
                      @click="action == 'Add' ? setSched(i) : null"
                    >
                      <div class="d-flex ga-2">
                        <div class="text-subtitle-1 font-weight-bold">
                          {{ i.day_desc }}
                        </div>
                      </div>
                      <div class="d-flex ga-2 justify-space-between">
                        <div class="text-caption">Morning In</div>
                        <div class="text-caption">
                          {{ formatTime(i.am_in) }}
                        </div>
                      </div>
                      <div class="d-flex ga-2 justify-space-between">
                        <div class="text-caption">Morning Out</div>
                        <div class="text-caption">
                          {{ formatTime(i.am_out) }}
                        </div>
                      </div>
                      <div class="d-flex ga-2 justify-space-between">
                        <div class="text-caption">Afternoon In</div>
                        <div class="text-caption">
                          {{ formatTime(i.pm_in) }}
                        </div>
                      </div>
                      <div class="d-flex ga-2 justify-space-between">
                        <div class="text-caption">Afternoon Out</div>
                        <div class="text-caption">
                          {{ formatTime(i.pm_out) }}
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div>
                    <v-data-table
                      :headers="headers"
                      :items="timeSchedule"
                      hover
                      hide-default-footer
                      density="compact"
                      class="rounded-lg"
                    >
                      <template v-slot:[`item.am_in`]="{ item }">
                        {{ formatTime(item.am_in) }}
                      </template>
                      <template v-slot:[`item.am_out`]="{ item }">
                        {{ formatTime(item.am_out) }}
                      </template>
                      <template v-slot:[`item.pm_in`]="{ item }">
                        {{ formatTime(item.pm_in) }}
                      </template>
                      <template v-slot:[`item.pm_out`]="{ item }">
                        {{ formatTime(item.pm_out) }}
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          v-if="action != 'View'"
                          class="white--text"
                          color="#00A63E"
                          size="x-small"
                          rounded
                          @click="action != 'View' ? setSched(item) : null"
                        >
                          {{ action != "View" ? "Set" : null }}
                        </v-btn>
                      </template>

                      <template #no-data>
                        You have not created your coretime.
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="pending()"
              v-if="action == 'Approve'"
            >
              <v-icon>mdi-close-circle-outline</v-icon>
              Pending
            </v-btn>
            <v-btn
              v-if="action == 'Approve'"
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="approve()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Approve
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
    approvalByFieldOfficer: Boolean,
  },
  data() {
    return {
      headers: [
        { title: "Day of Week", value: "day_desc", align: "start" },
        { title: "AM IN", value: "am_in", align: "center" },
        { title: "AM OUT", value: "am_out", align: "center" },
        { title: "PM IN", value: "pm_in", align: "center" },
        { title: "PM OUT", value: "pm_out", align: "center" },
      ],
      sc_data: null,
      setTimeDialog: false,
      isSetGlobal: false,
      dialog: false,
      date_from: null,
      date_to: null,
      schedules: [],
      btnLoading: false,
      deletedFile: null,
      showDatePicker1: false,
      showDatePicker2: false,
      showTimePicker1: false,
      showTimePicker2: false,
      showTimePicker3: false,
      showTimePicker4: false,
      am_in: null,
      am_out: null,
      pm_in: null,
      pm_out: null,
      day_desc: null,
      selectedSched: null,
      selectedDays: [],
      daysArr: [
        { id: 1, name: "Monday" },
        { id: 2, name: "Tuesday" },
        { id: 3, name: "Wednesday" },
        { id: 4, name: "Thursday" },
        { id: 5, name: "Friday" },
      ],
      timeSchedule: [
        {
          day: 1,
          day_desc: "Monday",
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
        },
        {
          day: 2,
          day_desc: "Tuesday",
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
        },
        {
          day: 3,
          day_desc: "Wednesday",
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
        },
        {
          day: 4,
          day_desc: "Thursday",
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
        },

        {
          day: 5,
          day_desc: "Friday",
          am_in: null,
          am_out: null,
          pm_in: null,
          pm_out: null,
        },
      ],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.sc_data = data;
        this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.axiosCall(
        "/student-coretime/getSchedulebyId/" + this.sc_data.id,
        "GET",
      ).then((res) => {
        console.log(res.data);
        this.date_from = res.data.date_from;
        this.date_to = res.data.date_to;
        this.timeSchedule = res.data.timeSchedule;
      });
    },

    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },

    deleteFile() {
      console.log(typeof this.moa_file);
      if (typeof this.moa_file == "string") {
        this.deletedFile = this.moa_file;
      }

      this.moa_file = null;
      this.file_desc = null;
      this.valid_until = null;
    },

    saveDateFrom() {
      if (this.date_from) {
        this.date_from = this.formatDate3(this.date_from);
        this.showDatePicker1 = false;
      }
    },

    saveDateTo() {
      if (this.date_to) {
        this.date_to = this.formatDate3(this.date_to);
        this.showDatePicker2 = false;
      }
    },

    saveTimeAM_IN() {
      if (this.am_in) {
        console.log(this.am_in);
        // this.am_in = this.formatDate3(this.am_in);
        this.showTimePicker1 = false;
      }
    },

    saveTimeAM_OUT() {
      if (this.am_out) {
        // this.am_out = this.formatDate3(this.am_out);
        this.showTimePicker2 = false;
      }
    },

    saveTimePM_IN() {
      if (this.pm_in) {
        // this.pm_in = this.formatDate3(this.pm_in);
        this.showTimePicker3 = false;
      }
    },

    saveTimePM_OUT() {
      if (this.pm_out) {
        // this.pm_out = this.formatDate3(this.pm_out);
        this.showTimePicker4 = false;
      }
    },

    setT() {
      this.isSetGlobal = true;
      this.setTimeDialog = true;
    },

    setSched(item) {
      this.isSetGlobal = false;
      this.selectedSched = item;
      this.day_desc = item.day_desc;
      this.am_in = item.am_in;
      this.am_out = item.am_out;
      this.pm_in = item.pm_in;
      this.pm_out = item.pm_out;
      this.setTimeDialog = true;
      this.$refs.TimeForm.resetValidation();
    },

    async saveTimeSched() {
      let formValid = await this.$refs.TimeForm.validate();
      this.btnLoading = true;
      if (formValid.valid) {
        if (this.isSetGlobal) {
          console.log(this.selectedDays);
          for (let i = 0; i < this.selectedDays.length; i++) {
            let idxOf = this.timeSchedule.findIndex(
              (data) => data.day == this.selectedDays[i],
            );

            this.timeSchedule[idxOf].am_in = this.am_in;
            this.timeSchedule[idxOf].am_out = this.am_out;
            this.timeSchedule[idxOf].pm_in = this.pm_in;
            this.timeSchedule[idxOf].pm_out = this.pm_out;
          }
        } else {
          let idxOf = this.timeSchedule.findIndex(
            (data) => data.day == this.selectedSched.day,
          );

          this.timeSchedule[idxOf].am_in = this.am_in;
          this.timeSchedule[idxOf].am_out = this.am_out;
          this.timeSchedule[idxOf].pm_in = this.pm_in;
          this.timeSchedule[idxOf].pm_out = this.pm_out;
        }

        this.btnLoading = false;
        this.setTimeDialog = false;
      }
    },

    async approve() {
      let formValid = await this.$refs.StudentCoretimeForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;

        this.axiosCall(
          "/student-coretime/approve/" +
            this.sc_data.id +
            "/" +
            this.approvalByFieldOfficer,
          "PATCH",
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async pending() {
      let formValid = await this.$refs.StudentCoretimeForm.validate();

      if (formValid.valid) {
        this.btnLoading = true;

        this.axiosCall(
          "/student-coretime/pending/" + this.sc_data.id,
          "PATCH",
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeStudentCoretimeDialog", true);
      this.dialog = false;
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
.box {
  width: 200px;
  cursor: pointer;
}
.box:hover {
  background-color: #00a63e;
  color: white;
}
</style>
